module.exports = __webpack_public_path__ + "img/hakan.52995d57.jpg";